export enum FreelanceEmployeeStep {
  STRUCTURE = 'structure',
  FORM = 'form',
}

export const PARTICIPANT_TAB_INDEX = {
  ORGANIZATION_STRUCTURE: 0,
  EXCEL_IMPORT: 1,
  FREELANCE_EMPLOYEE: 2,
};
